export default __webpack_public_path__ + "static/TCPOccupationalHealthSafetyPolicy_5.31.22-7db87850fb7469ee20fa4948bb3e203d.pdf";